(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-filters"]) return;
  try {
    
  // Mouse drag-to-scroll for the tag pill row. Touch devices already scroll
  // natively, so only mouse pointers are handled.
  document.querySelectorAll('.blog-filter-tags').forEach((row) => {
    if (row.dataset.dragScroll) return;
    row.dataset.dragScroll = 'true';

    const DRAG_THRESHOLD = 5;
    let startX = 0;
    let startScroll = 0;
    let pointerDown = false;
    let dragged = false;

    row.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerDown = true;
      dragged = false;
      startX = event.clientX;
      startScroll = row.scrollLeft;
    });

    row.addEventListener('pointermove', (event) => {
      if (!pointerDown) return;
      const delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) < DRAG_THRESHOLD) return;
      if (!dragged) {
        dragged = true;
        row.setPointerCapture(event.pointerId);
        row.classList.add('is-dragging');
      }
      row.scrollLeft = startScroll - delta;
    });

    const endDrag = () => {
      pointerDown = false;
      row.classList.remove('is-dragging');
    };
    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);

    // Swallow the click that follows a drag so pills don't navigate
    row.addEventListener(
      'click',
      (event) => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      },
      true
    );

    // Stop native link/image drag from hijacking the gesture
    row.addEventListener('dragstart', (event) => event.preventDefault());

    // Toggle the left edge fade once the row has scrolled away from the start
    const updateScrolled = () => {
      row.classList.toggle('is-scrolled', row.scrollLeft > 0);
    };
    row.addEventListener('scroll', updateScrolled, { passive: true });
    updateScrolled();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloomreach-collection"] && !Shopify.designMode) return;
  try {
    
  const mediaQuery = window.matchMedia('(min-width: 750px)');
  const section = document.querySelector('.section--bloomreach');

  function restoreGridState(wrapper) {
    const key = mediaQuery.matches ? 'product-grid-view-desktop' : 'product-grid-view-mobile';
    const saved = sessionStorage.getItem(key);

    if (!saved) return;

    const input = wrapper.querySelector(`input[value="${saved}"]`);
    if (input) input.checked = true;

    const grid = wrapper.closest('.collection-wrapper')?.querySelector('.br-products-grid');
    if (grid) grid.setAttribute('product-grid-view', saved);
  }

  function attachGridListeners(wrapper) {
    restoreGridState(wrapper);
    mediaQuery.addEventListener('change', () => restoreGridState(wrapper));

    wrapper.addEventListener('change', (evt) => {
      if (evt.target.type !== 'radio') return;

      const key = mediaQuery.matches ? 'product-grid-view-desktop' : 'product-grid-view-mobile';
      sessionStorage.setItem(key, evt.target.value);

      const grid = wrapper.closest('.collection-wrapper')?.querySelector('.br-products-grid');
      if (grid) grid.setAttribute('product-grid-view', evt.target.value);
    });
  }


  function initWishlistButtons(swat) {
    const wishlisted = new Set();

    function applyWishlistState() {
      section?.querySelectorAll('br-product-card').forEach((card) => {
        const btn = card.shadowRoot?.querySelector('[data-swaction="addToWishlist"]');
        if (!btn) return;
        const key = `${btn.dataset.productid}_${btn.dataset.variantid}`;
        const saved = wishlisted.has(key);
        btn.classList.toggle('swym-added', saved);
        btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }

    // SwymWishlistFetched fires on initial load and after every add/remove from
    // any source (collection buttons, header drawer, account page) — keeps the
    // wishlisted Set permanently in sync without a separate swat.fetch call.
    document.addEventListener('SwymWishlistFetched', (event) => {
      wishlisted.clear();
      (event.detail?.defaultList?.listcontents || []).forEach((item) => {
        wishlisted.add(`${item.empi}_${item.epi}`);
      });
      applyWishlistState();
    });

    // Bloomreach renders cards as shadow DOM custom elements — watch for renders
    // (initial load, pagination, filter changes) and re-apply saved state each time.
    if (section) {
      let applyTimer;
      new MutationObserver(() => {
        clearTimeout(applyTimer);
        applyTimer = setTimeout(applyWishlistState, 100);
      }).observe(section, { childList: true, subtree: true });
    }

    // swat.initializeActionButtons() cannot pierce shadow DOM so we use
    // event.composedPath() to intercept clicks on shadow DOM buttons.
    document.addEventListener('click', (event) => {
      const path = event.composedPath();
      const btn = path.find((el) => el?.dataset?.swaction === 'addToWishlist');
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();

      const product = {
        epi: parseInt(btn.dataset.variantid, 10),
        empi: parseInt(btn.dataset.productid, 10),
        du: btn.dataset.et,
        iu: btn.dataset.iu,
      };
      const key = `${product.empi}_${product.epi}`;

      if (wishlisted.has(key)) {
        swat.removeFromWishList(product, () => {
          wishlisted.delete(key);
          btn.classList.remove('swym-added');
          btn.setAttribute('aria-label', 'Add to wishlist');
        }, () => {});
      } else {
        swat.addToWishList(product, () => {
          wishlisted.add(key);
          btn.classList.add('swym-added');
          btn.setAttribute('aria-label', 'Remove from wishlist');
        }, () => {});
      }
    });
  }

  if (window._swat) {
    initWishlistButtons(window._swat);
  } else {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(initWishlistButtons);
  }

  // Bloomreach renders each card as a shadow DOM custom element, so the
  // page-level stylesheet can't reach the price/add-to-cart layout inside it.
  // Inject a scoped override into each card's shadow root instead: group--right
  // is forced to align-items: start upstream, which leaves group-content
  // (price + button) pinned to the top instead of stretching to match
  // group--left. When group--left wraps an extra line (e.g. rental price rate
  // text), the button drifts out of alignment with cards that didn't wrap.
  function injectCardStyleOverrides(card) {
    const root = card.shadowRoot;
    if (!root || root.querySelector('style[data-br-atc-align]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-br-atc-align', '');
    style.textContent = `
      .br-product-card__group--right { align-items: stretch !important; }
      .br-product-card__group--right .br-product-card__group-content {
        height: 100%;
        justify-content: space-between !important;
      }
    `;
    root.appendChild(style);
  }

  if (section) {
    const columnOptionsWrapper = section.querySelector('.column-options-wrapper');
    if (columnOptionsWrapper) attachGridListeners(columnOptionsWrapper);

    section.querySelectorAll('br-product-card').forEach(injectCardStyleOverrides);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          const wrapper = node.classList?.contains('column-options-wrapper')
            ? node
            : node.querySelector?.('.column-options-wrapper');
          if (wrapper) attachGridListeners(wrapper);

          const searchInput = node.querySelector?.('[data-br-search-input]');
          if (searchInput && !searchInput.value) {
            searchInput.value = new URLSearchParams(window.location.search).get('q') || '';
          }

          if (node.matches?.('br-product-card')) injectCardStyleOverrides(node);
          node.querySelectorAll?.('br-product-card').forEach(injectCardStyleOverrides);
        }
      }
      // Shadow roots can attach asynchronously after the host node is inserted,
      // so retry once the render has had a moment to settle.
      setTimeout(() => {
        section.querySelectorAll('br-product-card').forEach(injectCardStyleOverrides);
      }, 100);
    }).observe(section, { childList: true, subtree: true });
  }

  document.addEventListener('submit', (e) => {
    if (!e.target.hasAttribute('data-br-search-form')) return;
    e.preventDefault();
    const q = e.target.querySelector('[data-br-search-input]')?.value.trim();
    if (!q) return;
    const params = new URLSearchParams(window.location.search);
    params.set('q', q);
    // On search pages the BR widget reacts to popstate — update in place without a full reload.
    // On collection pages fall back to a full navigation.
    if (document.querySelector('.br-widget-host--search')) {
      history.pushState({}, '', '?' + params.toString());
      window.dispatchEvent(new PopStateEvent('popstate', { state: {} }));
    } else {
      window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-br-search-clear]')) return;
    const input = e.target.closest('[data-br-search-form]')?.querySelector('[data-br-search-input]');
    if (input) { input.value = ''; input.focus(); }
  });

  function initBrQuickAdd() {
    document.addEventListener('click', async (event) => {
      const btn = event.composedPath().find(
        (el) => el?.hasAttribute?.('data-br-product-card-add')
      );
      if (!btn) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;

      try {
        // Collect section IDs from cart-items-component elements so Shopify returns
        // pre-rendered section HTML alongside the add response — same approach as
        // product-form-component. This lets cart-items-component morph immediately
        // instead of doing a separate async fetch (which causes the empty-drawer flash).
        const sectionIds = Array.from(
          document.querySelectorAll('cart-items-component[data-section-id]')
        ).map((el) => el.dataset.sectionId);

        const body = { id: parseInt(variantId, 10), quantity: 1 };
        if (sectionIds.length > 0) {
          body.sections = sectionIds.join(',');
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });

        if (!response.ok) throw new Error('Cart add failed');

        const data = await response.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: data, data: { variantId, sections: data.sections } },
        }));
      } catch (err) {
        console.error('Bloomreach quick add failed:', err);
      } finally {
        btn.disabled = false;
      }
    });
  }

  initBrQuickAdd();

  function initFilterHeightLock() {
    let lastGoodHeight = 0;
    let initialLoadDone = false;

    new MutationObserver((mutations) => {
      const container = document.querySelector('.br-collections__results, .br-search-widget__results');
      if (!container) return;

      for (const { addedNodes, removedNodes } of mutations) {
        for (const node of addedNodes) {
          if (!node.classList?.contains('br-results-skeleton')) continue;
          if (!initialLoadDone) continue;
          container.classList.add('br-filtering');
          container.style.minHeight = lastGoodHeight + 'px';
        }
        for (const node of removedNodes) {
          if (!node.classList?.contains('br-results-skeleton')) continue;
          if (!initialLoadDone) { initialLoadDone = true; continue; }
          setTimeout(() => {
            container.classList.remove('br-filtering');
            container.style.minHeight = '';
            document.dispatchEvent(new CustomEvent('bloomreach:results-loaded'));
          }, 300);
        }
      }

      // Snapshot height only when stable (minHeight not active)
      if (!container.style.minHeight && container.offsetHeight > 0) {
        lastGoodHeight = container.offsetHeight;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  initFilterHeightLock();

  document.addEventListener('click', (e) => {
    const facetsShowAllBtn = e.composedPath().find(el => el.dataset?.brFacetsShowAll);
    if (!facetsShowAllBtn) return;
    const facetsCount = parseInt(facetsShowAllBtn.dataset.brFacetsShowAll, 10);
    if (!facetsCount) return;
    facetsShowAllBtn.getRootNode().host.expandedCount = facetsCount;
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-listing"] && !Shopify.designMode) return;
  try {
    
  class BrandsListing extends HTMLElement {
    constructor() {
      super();
      this.letterButtons = this.querySelectorAll('.brands-listing__letter-button');
      this.brandGroups = this.querySelectorAll('.brand-letter-group');
      this.searchInput = this.querySelector('[data-brand-search]');
      this.brandLinks = this.querySelectorAll('.brand-link');
      this.init();
    }

    init() {
      this.letterButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          
          const letter = button.dataset.letter;
          
          if (letter === 'all') {
            this.showAllGroups();
          } else {
            this.filterByLetter(letter);
          }
        });
      });

      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => {
          this.handleSearch(e.target.value);
        });
      }
    }

    filterByLetter(letter) {
      const upperLetter = letter.toUpperCase();

      this.brandGroups.forEach(group => {
        const groupLetter = group.dataset.letter;
        const wrapper = group.closest('.shopify-block') || group;
        if (groupLetter === upperLetter) {
          wrapper.style.display = 'block';
        } else {
          wrapper.style.display = 'none';
        }
      });
      
      // Show all brands within visible groups
      this.brandLinks.forEach(link => {
        const group = link.closest('.brand-letter-group');
        const wrapper = group && (group.closest('.shopify-block') || group);
        if (wrapper && wrapper.style.display !== 'none') {
          link.style.display = 'list-item';
        }
      });

      this.updateActiveButton(letter);
    }

    handleSearch(query) {
      const searchTerm = query.toLowerCase().trim();
      
      if (searchTerm === '') {
        this.showAllGroups();
        this.brandLinks.forEach(link => {
          link.style.display = 'list-item';
        });
        return;
      }

      let visibleGroups = new Set();

      this.brandLinks.forEach(link => {
        const brandName = link.dataset.brand;
        const matches = brandName && brandName.includes(searchTerm);
        
        link.style.display = matches ? 'list-item' : 'none';
        
        if (matches) {
          const group = link.closest('.brand-letter-group');
          if (group) {
            visibleGroups.add(group);
          }
        }
      });

      this.brandGroups.forEach(group => {
        const wrapper = group.closest('.shopify-block') || group;
        wrapper.style.display = visibleGroups.has(group) ? 'block' : 'none';
      });
    }

    showAllGroups() {
      this.brandGroups.forEach(group => {
        const wrapper = group.closest('.shopify-block') || group;
        wrapper.style.display = 'block';
      });
      this.brandLinks.forEach(link => {
        link.style.display = 'list-item';
      });
      this.updateActiveButton('all');
    }

    updateActiveButton(activeLetter) {
      this.letterButtons.forEach(button => {
        const letter = button.dataset.letter;
        if (letter === activeLetter) {
          button.classList.add('active');
          button.setAttribute('aria-current', 'true');
        } else {
          button.classList.remove('active');
          button.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('brands-listing', BrandsListing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner-inject"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MAX_TRIES = 50;
    var tries = 0;

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buildHTML() {
      console.log('buildHTML', window.bannerTitle, window.bannerText);
      var parts = [];

      if (window.bannerLink) {
        var label = window.bannerTitle ? ' aria-label="' + escapeHtml(window.bannerTitle) + '"' : '';
        parts.push('<a class="collection-banner__bg" href="' + escapeHtml(window.bannerLink) + '"' + label + '>');
      } else {
        parts.push('<div class="collection-banner__bg">');
      }
      if (window.bannerImage) {
        parts.push('<div class="collection-banner__bg-img collection-banner__bg-img--desktop">' + window.bannerImage + '</div>');
      }
      if (window.bannerImageMobile) {
        parts.push('<div class="collection-banner__bg-img collection-banner__bg-img--mobile">' + window.bannerImageMobile + '</div>');
      }
      parts.push(window.bannerLink ? '</a>' : '</div>');

      // Gradient only exists for text legibility — skip it when there's no text
      if (window.bannerTitle || window.bannerText) {
        parts.push('<div class="collection-banner__overlay" aria-hidden="true"></div>');
      }

      parts.push('<div class="collection-banner__inner">');

      parts.push('<div class="collection-banner__content">');
      if (window.bannerTitle) {
        parts.push('<h2 class="collection-banner__title">' + escapeHtml(window.bannerTitle) + '</h2>');
      }
      if (window.bannerText) {
        parts.push('<p class="collection-banner__body">' + escapeHtml(window.bannerText) + '</p>');
      }
      parts.push('</div>');

      if (window.bannerOverlayImage) {
        parts.push('<div class="collection-banner__overlay-img" aria-hidden="true">' + window.bannerOverlayImage + '</div>');
      }

      parts.push('</div>');

      return parts.join('');
    }

    function injectBanner() {
      var el = document.querySelector('.collection-banner');
      if (!el) return false;
      if (!window.bannerImage && !window.bannerImageMobile && !window.bannerTitle && !window.bannerText && !window.bannerOverlayImage) return true;
      el.innerHTML = buildHTML();
      // Size the banner to the image's aspect ratio so it is never cropped
      if (window.bannerAspect) {
        el.style.setProperty('--banner-aspect', window.bannerAspect);
        el.classList.add('collection-banner--has-image');
      }
      if (window.bannerAspectMobile) {
        el.style.setProperty('--banner-aspect-mobile', window.bannerAspectMobile);
        el.classList.add('collection-banner--has-image-mobile');
      }
      el.classList.toggle('collection-banner--linked', !!window.bannerLink);
      el.classList.add('collection-banner--populated');
      return true;
    }

    var interval = setInterval(function () {
      tries++;
      if (injectBanner() || tries >= MAX_TRIES) clearInterval(interval);
    }, 200);

    document.addEventListener('bloomreach:results-loaded', injectBanner);

    console.log('collection-banner-inject', window.bannerTitle, window.bannerText);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  class DdBrandCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dd-brand-carousel__track');
      this.querySelectorAll('.dd-brand-carousel__arrow').forEach((btn) => {
        btn.addEventListener('click', () => this.#navigate(Number(btn.dataset.direction)));
      });
    }

    #navigate(direction) {
      if (!this.track) return;
      const item = this.track.querySelector('.dd-brand-carousel__item');
      const itemWidth = item ? item.offsetWidth : 160;
      const gap = 16;
      this.track.scrollBy({ left: direction * (itemWidth + gap) * 3, behavior: 'smooth' });
    }
  }

  if (!customElements.get('dd-brand-carousel')) {
    customElements.define('dd-brand-carousel', DdBrandCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventbrite-events"] && !Shopify.designMode) return;
  try {
    
  class EventbriteEvents {
    constructor(root) {
      this.root = root;
      this.apiUrl = root.dataset.apiUrl;
      this.pastLimit = parseInt(root.dataset.pastLimit, 10) || 10;
      this.currentVisibleLimit = parseInt(root.dataset.currentVisibleLimit, 10) || 5;

      this.currentGroup = root.querySelector('[data-events-current]');
      this.currentList = root.querySelector('[data-events-current-list]');
      this.currentLoadMore = root.querySelector('[data-events-current-load-more]');
      this.currentTemplate = document.querySelector('[data-event-current-template]');

      this.pastHeading = root.querySelector('[data-events-past-heading]');
      this.pastGroup = root.querySelector('[data-events-past]');
      this.pastCards = Array.from(root.querySelectorAll('.eventbrite-events__carousel .event-card--past'));

      if (!this.apiUrl) return;

      this.load();
    }

    async load() {
      try {
        const response = await fetch(`${this.apiUrl}/events`);
        if (!response.ok) throw new Error(`Eventbrite middleware responded with ${response.status}`);

        const data = await response.json();
        const events = Array.isArray(data.events) ? data.events : [];

        const current = events.filter((event) => event.status === 'live');
        const past = events
          .filter((event) => event.status === 'completed')
          .slice(0, this.pastLimit);

        this.renderCurrent(current);
        this.renderPast(past);
      } catch (error) {
        console.error('[eventbrite-events]', error);
      }
    }

    renderCurrent(events) {
      if (!events.length || !this.currentTemplate) return;

      events.forEach((event, index) => {
        const card = this.currentTemplate.content.cloneNode(true).firstElementChild;
        this.populateCard(card, event);
        if (index >= this.currentVisibleLimit) {
          card.hidden = true;
        }
        this.currentList.appendChild(card);
      });

      if (events.length > this.currentVisibleLimit && this.currentLoadMore) {
        this.currentLoadMore.hidden = false;
        this.currentLoadMore.addEventListener('click', () => {
          this.currentList.querySelectorAll('[hidden]').forEach((card) => {
            card.hidden = false;
          });
          this.currentLoadMore.hidden = true;
        });
      }

      this.currentGroup.hidden = false;
    }

    renderPast(events) {
      if (!events.length || !this.pastCards.length) return;

      this.pastCards.forEach((card, index) => {
        const event = events[index];
        // Slides are pre-rendered up to the configured limit; remove any
        // that don't have a matching event so the carousel doesn't count
        // empty slots as navigable slides.
        const slide = card.closest('slideshow-slide');
        if (!event) {
          if (slide) slide.remove();
          return;
        }
        this.populateCard(card, event, { showDescription: false });
      });

      this.pastGroup.hidden = false;
      if (this.pastHeading) this.pastHeading.hidden = false;
    }

    populateCard(card, event, options = {}) {
      const showDescription = options.showDescription !== false;

      const imageLink = card.querySelector('.event-card__image-link');
      const image = card.querySelector('.event-card__image');
      const title = card.querySelector('.event-card__title');
      const description = card.querySelector('.event-card__description');
      const date = card.querySelector('.event-card__date');
      const link = card.querySelector('.event-card__link');

      const url = event.url || '';
      const name = event.name?.text || '';
      // event.logo.url is a pre-cropped 450x200 thumbnail; original.url is
      // the full-resolution source image (e.g. 940x470), which lets our own
      // aspect-ratio/object-fit CSS do the cropping instead of Eventbrite's.
      const logoUrl = event.logo?.original?.url || event.logo?.url || '';

      if (imageLink) imageLink.href = url;
      if (image) {
        image.src = logoUrl;
        image.alt = name;
      }
      if (title) title.textContent = name;

      if (showDescription && description) {
        description.textContent = event.description?.text || '';
      } else if (description) {
        description.remove();
      }

      if (date) {
        const start = event.start?.local;
        date.textContent = start
          ? new Date(start).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
          : '';
      }

      if (link) link.href = url;
    }
  }

  document.querySelectorAll('[data-eventbrite-events]').forEach((root) => new EventbriteEvents(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Show the digi-menu backdrop blur when the Bloomreach autosuggest dropdown is visible.
  (function () {
    function init() {
      const backdrop = document.querySelector('[data-menu-backdrop]');
      if (!backdrop) return;

      function showBackdrop() {
        const header = document.querySelector('.header-section, header');
        const top = header ? header.getBoundingClientRect().bottom : 0;
        backdrop.style.setProperty('--menu-backdrop-top', `${top}px`);
        backdrop.classList.add('digi-menu-backdrop--visible');
      }

      function isMegamenuOpen() {
        return document.querySelector('.digi-megamenu--active, .digi-image-menu--active') != null;
      }

      function hideBackdrop() {
        // Don't steal the backdrop away from an open megamenu/image-menu —
        // that's managed independently by megamenu.js.
        if (isMegamenuOpen()) return;
        backdrop.classList.remove('digi-menu-backdrop--visible');
      }

      let hideTimer = null;

      function isDropdownVisible() {
        const el = document.querySelector('.br-autosuggest--dropdown');
        if (!el) return false;
        // Once relocated into the search recs panel (br-autosuggest-recommendations.liquid),
        // the dropdown renders inside the search modal's own backdrop/blur —
        // this menu backdrop sits above that modal's z-index and would
        // otherwise cover the results.
        if (el.closest('.br-autosuggest-recs')) return false;
        return window.getComputedStyle(el).display !== 'none';
      }

      function checkDropdown() {
        if (isDropdownVisible()) {
          if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
          }
          showBackdrop();
        } else {
          if (hideTimer) return;
          hideTimer = setTimeout(() => {
            hideTimer = null;
            if (!isDropdownVisible()) hideBackdrop();
          }, 300);
        }
      }

      // Watch the whole subtree — Bloomreach may create/destroy the dropdown
      // element on each open rather than reusing it.
      new MutationObserver(() => requestAnimationFrame(checkDropdown))
        .observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mwave-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const HOVER_DELAY_MS = 150;

    function openSidebarMegamenu(menuHandle, categoryTrigger) {
      const manager = window.megamenuManager;

      if (manager?.openMegamenuWithCategory) {
        manager.openMegamenuWithCategory(menuHandle, categoryTrigger);
        return;
      }

      const megamenuWrapper =
        document.querySelector('.mwave-megamenu[data-menu-handle="' + menuHandle + '"]') ||
        document.querySelector('.mwave-megamenu');
      if (!megamenuWrapper) return;

      const triggerBtn = megamenuWrapper.querySelector('[data-megamenu-trigger]');
      if (triggerBtn?.getAttribute('aria-expanded') !== 'true') {
        triggerBtn?.click();
      }

      const menuId = megamenuWrapper.getAttribute('data-menu-id');
      const dropdown = document.querySelector('[data-dropdown-for="' + menuId + '"]');
      const categoryItem = dropdown?.querySelector(
        '[data-category-trigger="' + categoryTrigger + '"]'
      );
      categoryItem?.click();
    }

    // The shared slideshow-component only tracks the raw current tile index
    // and highlights dots by matching that index 1:1 against ref="dots[]"
    // position — fine for a dot-per-tile list, but our tile pagination is a
    // dot-per-"page" list, so it's built and kept in sync here instead.
    // Pages are derived from the real layout (displayed tiles, scroller
    // width) and rebuilt on resize, so the pill count is right at every
    // breakpoint and pills are hidden when nothing scrolls.
    function initTilePagination() {
      const carousel = document.querySelector('[ref="mwaveSlideshowTiles"]');
      const list = carousel?.querySelector('[data-mwave-tile-pagination]');
      if (!carousel || !list) return;

      const scroller = carousel.querySelector('slideshow-slides');
      const labelTemplate = list.getAttribute('data-label-template') || '';
      let pageStarts = [];
      let pageKey = '';

      function allSlides() {
        return carousel.slides || Array.from(carousel.querySelectorAll('slideshow-slide'));
      }

      // Each page is the slide index (in carousel.slides) a pill selects.
      function computePageStarts() {
        if (!scroller) return [];

        const slides = allSlides();
        const displayed = slides.filter(function (slide) {
          return slide.getClientRects().length > 0;
        });
        if (displayed.length < 2) return [];

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 1) return [];

        const origin = displayed[0].offsetLeft;
        const step = displayed[1].offsetLeft - origin || displayed[0].offsetWidth || 1;
        const gap = Math.max(0, step - displayed[0].offsetWidth);
        const perView = Math.max(1, Math.floor((scroller.clientWidth + gap + 1) / step));

        // Last displayed tile that can still reach the scroller's start edge;
        // beyond it the carousel is already scrolled to the end.
        let maxStart = displayed.length - 1;
        for (let i = 0; i < displayed.length; i++) {
          if (displayed[i].offsetLeft - origin >= maxScroll - 1) {
            maxStart = i;
            break;
          }
        }

        const starts = [];
        for (let i = 0; i < displayed.length; i += perView) {
          const start = Math.min(i, maxStart);
          if (starts[starts.length - 1] !== start) starts.push(start);
          if (start === maxStart) break;
        }
        if (starts[starts.length - 1] !== maxStart) starts.push(maxStart);

        return starts.map(function (i) {
          return slides.indexOf(displayed[i]);
        });
      }

      function updateActivePill(currentIndex) {
        // Pages can overlap once the last start is clamped, so the active
        // page is the last start at or before the current tile.
        let active = 0;
        pageStarts.forEach(function (start, i) {
          if (start <= currentIndex) active = i;
        });

        list.querySelectorAll('button').forEach(function (button, i) {
          if (i === active) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }

      function render() {
        const starts = computePageStarts();
        const key = starts.join(',');
        if (key === pageKey) return;

        pageKey = key;
        pageStarts = starts;
        list.replaceChildren();
        list.hidden = starts.length < 2;
        if (list.hidden) return;

        starts.forEach(function (start, i) {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'slideshow-control button';
          button.textContent = String(i + 1);
          button.setAttribute(
            'aria-label',
            labelTemplate.replace('__INDEX__', String(i + 1)).replace('__LENGTH__', String(starts.length))
          );
          button.addEventListener('click', function () {
            if (typeof carousel.select === 'function') carousel.select(start);
          });
          item.appendChild(button);
          list.appendChild(item);
        });

        updateActivePill(carousel.current ?? 0);
      }

      carousel.addEventListener('slideshow:select', function (event) {
        updateActivePill(event.detail.index);
      });

      let frame;
      function scheduleRender() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(render);
      }

      if (scroller && 'ResizeObserver' in window) {
        new ResizeObserver(scheduleRender).observe(scroller);
      } else {
        window.addEventListener('resize', scheduleRender);
      }
      render();
    }

    function initHeroDeviceVisibility() {
      const hero = document.querySelector('.mwave-slideshow__hero slideshow-component');
      if (!hero) return;

      const slides = Array.from(hero.querySelectorAll('slideshow-slide[data-device-visibility]'));
      if (!slides.length) return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');

      function applyVisibility() {
        const isMobile = mobileQuery.matches;
        let changed = false;

        slides.forEach(function (slide) {
          const visibility = slide.getAttribute('data-device-visibility');
          const shouldHide =
            (visibility === 'desktop_only' && isMobile) || (visibility === 'mobile_only' && !isMobile);

          if (shouldHide === slide.hasAttribute('hidden')) return;
          changed = true;

          if (shouldHide) {
            slide.setAttribute('hidden', '');
          } else {
            slide.removeAttribute('hidden');
          }
        });

        if (changed && typeof hero.select === 'function') {
          hero.select(0, undefined, { animate: false });
        }

        const singleSlide = (hero.slides?.length ?? 0) <= 1;
        hero.classList.toggle('mwave-slideshow__hero-carousel--single-slide', singleSlide);
      }

      applyVisibility();
      mobileQuery.addEventListener('change', applyVisibility);
    }

    function initHeroPagination() {
      const hero = document.querySelector('.mwave-slideshow__hero slideshow-component');
      const paginationLists = document.querySelectorAll('[data-mwave-hero-pagination]');
      if (!hero || !paginationLists.length) return;

      hero.addEventListener('slideshow:select', function (event) {
        paginationLists.forEach(function (list) {
          list.querySelectorAll('[data-slide-index]').forEach(function (pill) {
            const index = parseInt(pill.getAttribute('data-slide-index'), 10);

            if (index === event.detail.index) {
              pill.setAttribute('aria-current', 'true');
            } else {
              pill.removeAttribute('aria-current');
            }
          });
        });
      });
    }

    function initHeroAutoHeight() {
      const hero = document.querySelector('.mwave-slideshow__hero--auto-height');
      const heroComponent = hero?.querySelector('slideshow-component');
      if (!hero || !heroComponent) return;

      heroComponent.addEventListener('slideshow:select', function (event) {
        const img = event.detail.slide?.querySelector('.slide__image, .slide__video-poster');
        if (!img) return;

        const applyRatio = function () {
          if (img.naturalWidth && img.naturalHeight) {
            hero.style.setProperty('--hero-computed-aspect-ratio', img.naturalWidth + ' / ' + img.naturalHeight);
          }
        };

        if (img.complete) {
          applyRatio();
        } else {
          img.addEventListener('load', applyRatio, { once: true });
        }
      });
    }

    function initSidebarTriggers() {
      const nav = document.querySelector('[data-mwave-sidebar-menu]');
      const menuHandle = nav?.getAttribute('data-mwave-sidebar-menu');
      let hoverTimeout = null;

      document.querySelectorAll('[data-mwave-sidebar-trigger]').forEach(function (btn) {
        const openForButton = function () {
          const categoryTrigger = btn.getAttribute('data-mwave-sidebar-trigger');
          openSidebarMegamenu(menuHandle, categoryTrigger);
        };

        btn.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(openForButton, HOVER_DELAY_MS);
        });

        btn.addEventListener('mouseleave', function () {
          clearTimeout(hoverTimeout);
        });

        btn.addEventListener('focus', openForButton);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSidebarTriggers);
      document.addEventListener('DOMContentLoaded', initTilePagination);
      document.addEventListener('DOMContentLoaded', initHeroDeviceVisibility);
      document.addEventListener('DOMContentLoaded', initHeroPagination);
      document.addEventListener('DOMContentLoaded', initHeroAutoHeight);
    } else {
      initSidebarTriggers();
      initTilePagination();
      initHeroDeviceVisibility();
      initHeroPagination();
      initHeroAutoHeight();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document
    .querySelectorAll('[data-testid="product-list"][data-collection-handle]')
    .forEach(function (el) {
      var handle = el.getAttribute('data-collection-handle');
      if (!handle) return;
      try {
        localStorage.setItem(
          'br_collection_meta:' + handle,
          JSON.stringify({
            id: el.getAttribute('data-collection-id'),
            title: el.getAttribute('data-collection-title'),
          }),
        );
      } catch (e) {
        // localStorage unavailable (private mode, etc.) — non-critical.
      }
    });

  } catch(e) { console.error(e); }
})();
})();
